import {
    CButton,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPencil } from "@coreui/icons";
import TableCaption from './TableCaption';
import TableFooterV2 from './TableFooterV2';
import styles from './Table.module.css';



const Table = ({
    columns,
    data,
    pagination,
    setFaqsPage,
    handlePetMemorialSelected,
}) => {
  
    return (
        <>
            <div className="col-12">
            <TableCaption pagination={pagination} noun="recuerdos" />
            <div className={styles.tableCard}>
            <CTable responsive className={styles.styledTable}>
                <CTableHead>
                    <CTableRow>
                        {columns.map((col, index) => (
                            <CTableHeaderCell
                                key={index}
                                scope="col"
                                className={col._props.className}
                                style={{whiteSpace: "nowrap"}}
                            >
                                {col.label}
                            </CTableHeaderCell>
                        ))}
                    </CTableRow>
                </CTableHead>
                <CTableBody>
                    {data.map((el, index) => {
                    return (
                        <CTableRow key={index}>
                            <CTableDataCell>{el?.id}</CTableDataCell>
                            <CTableDataCell>{el?.pet.name}</CTableDataCell>
                            <CTableDataCell>
                                {el?.user.name}
                            </CTableDataCell>
                            <CTableDataCell>
                                {el?.user.id}
                            </CTableDataCell>
                            <CTableDataCell>
                                {el?.user.email}
                            </CTableDataCell>
                            <CTableDataCell>
                                {el?.user.phone_country_code}
                            </CTableDataCell>
                            <CTableDataCell>
                                {el?.user.phone_area_code}
                            </CTableDataCell>
                            <CTableDataCell>
                                {!el.user?.phone_country_code ? el.user?.phone : el.user?.phone_number}  
                            </CTableDataCell>
                            <CTableDataCell>
                                {el?.instagram_handle}
                            </CTableDataCell>
                            <CTableDataCell>{el?.status.name}</CTableDataCell>
                            <CTableDataCell>
                                <div className="d-flex gap-2">
                                    <CButton
                                        color="primary"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => {
                                            handlePetMemorialSelected(
                                                el.id,
                                                "edit"
                                            );
                                        }}
                                    >
                                        <CIcon icon={cilPencil} />
                                    </CButton>
                                </div>
                            </CTableDataCell>
                        </CTableRow>
                    );})}
                </CTableBody>
            </CTable>
            {!data || data.length === 0 ? (
              <div className={styles.emptyState}>No se encontraron resultados.</div>
            ) : null}
            </div>
            </div>
            <TableFooterV2 range={pagination?.links} setPage={setFaqsPage} />
        </>
    );
};

export default Table;
